export default __webpack_public_path__ + "1ccd996b42040b5900f33e9fe4c78cd7.png";